//@flow

import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 33%;
  flex-basis: 33%;

  & + & {
    margin-left: 1rem;
  }
`



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/LocationMetrics.js